<template>
  <initio-page-header-and-footer>
      <div class="column is-12 progress-bar" :class="[ isSuccessPage , `progress-bar-${ this.currentSession.stepPath.length -1 }`]" v-if="!hideProgressBar"></div>
      <div class="section">
        <div class="container">
          <div v-if="adminImpersonate" class="columns">
            <div class="column" :class="[ env && env !== 'production', 'is-8']">
              <div class='notification is-danger subtitle is-size-6 is-flex is-align-items-stretch'>
                <div><span class="has-text-weight-bold mr-2">
                  Logged in as client:</span>
                  {{ client.first_name }} {{ client.last_name }} |
                  #<a target="_blank" :href="`/admin/index.php?show=users&cli_num=${client.cli_num}`">{{ client.cli_num }}</a> |
                  {{ client.email }}
                </div>
                <div class="ml-auto"><a href="/app/logout">Logout</a></div>
              </div>
            </div>
            <div class="column">
              <div v-if="env && env !== 'production'" class='notification is-warning subtitle is-size-6'>
                {{ env | capitalize }} Environment
              </div>
            </div>
          </div>
          <div class="container">
            <div class="columns">
              <div class="column">
                <initio-back-button v-if="!hideBack" />
                <h1 class="panel--title">
                  <slot name="title">
                    Please add:
                    <pre>
                    &lt;initio-panel&gt;
                      &lt;template v-slot:title&gt;
                        Your title here
                      &lt;/template&gt;
                    &lt;initio-panel&gt;
                  </pre>
                  </slot>
                </h1>
              </div>
            </div>
          </div>
          <div class="columns column-reverse-mobile">
            <div class="column">
              <div class="initio-panel">
                <h3 class="panel--label">
                  <slot name="label">
                  </slot>
                </h3>
                <slot name="before_form"></slot>
                <initio-formulate-base :hide-submit="hideSubmit" v-on="$listeners">
                  <template v-slot:form_bottom>
                    <slot name="form_bottom"></slot>
                  </template>
                  <template v-slot:form_footer>
                    <slot name="form_footer"></slot>
                  </template>
                  <template slot="errors">
                    <ul class="errors">
                      <li class="notification is-danger" v-for="(error, key) in errors" :key="key">
                        <!-- accept html -->
                        <div v-html="error"></div>
                      </li>
                    </ul>
                  </template>
                </initio-formulate-base>
                <slot name="after_form"></slot>
              </div>
            </div>

            <div class="column is-3-desktop is-4-tablet is-offset-1-desktop" v-if="$slots.sidebar">
              <slot name="sidebar"></slot>
            </div>
          </div>
        </div>
      </div>
  </initio-page-header-and-footer>
</template>

<script>

import { mapGetters } from 'vuex'
import InitioFormulateBase from './InitioFormulateBase.vue'
import InitioBackButton from './InitioBackButton.vue'
import InitioPageHeaderAndFooter from './InitioPageHeaderAndFooter.vue'

export default {
  name: 'InitioPanel',
  inject: ['checkAdminImpersonate'],
  props: {
    hideProgressBar: {
      type: Boolean,
      required: false,
      default: false
    },
    hideBack: {
      type: Boolean,
      required: false,
      default: false
    },
    hideSubmit: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Array,
      required: false
    }
  },
  components: {
    InitioFormulateBase,
    InitioBackButton,
    InitioPageHeaderAndFooter,
  },
  computed: {
      ...mapGetters(['currentSession', 'client', 'env']),
      isSuccessPage: {
        get () {
          let success = ['Vehicle.Success'];
          let currentStep = this.currentSession.stepPath[ this.currentSession.stepPath.length - 1 ];

          if ( success.some( v => currentStep.includes( v ) ) ) {
            // is success step
            return 'progress-bar--complete';
          } else {
            // not success step
            return false;
          }
        }
      },
    adminImpersonate(){
      return this.checkAdminImpersonate();
    }
  },
  methods: {
    
  },
  data () {
    return {
      progress: 1
    }
  }
}

</script>

<style scoped lang="scss">

  .hide {
    display:none;
  }

  h1.panel--title {
    margin-bottom:1rem;
  }
  .progress-bar {
    width:100%;
    height:8px;
    background:$light-grey;
    padding:0;
    margin:0;
    position:absolute;
    display:block;
    left:0;

    &:after {
      width:50%;
      display:block;
      content:"";
      background:#82B541;
      height:100%;
      left:0;
      position:absolute;
      top:0;
    }

    &-0 {
      &:after {
        width:10%;
      }
    }
    &-1 {
      &:after {
        width:28%;
      }
    }
    &-2 {
      &:after {
        width:42%;
      }
    }
    &-3 {
      &:after {
        width:54%;
      }
    }
    &-4 {
      &:after {
        width:63%;
      }
    }
    &-5 {
      &:after {
        width:70%;
      }
    }
    &-6 {
      &:after {
        width:76%;
      }
    }
    &-7 {
      &:after {
        width:81%;
      }
    }
    &-8 {
      &:after {
        width:85%;
      }
    }
    &-9 {
      &:after {
        width:88%;
      }
    }
    &-10 {
      &:after {
        width:91%;
      }
    }
    &--complete {
      &:after {
        width:100%;
      }
    }
  }
  .back {
    font-size:0.9rem;

    &:before {
      content:"\2190";
      display:inline-block;
      padding-right:0.5rem;
    }
  }

  @include mobile() {
    .column-reverse-mobile {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  /* this is to prevent auto-zooming on inputs in iOS */
  //@supports (-webkit-overflow-scrolling: touch) {
    input {
      font-size: 16px;
    }
    .formulate-input input, .formulate-input select {
      font-size: 16px;
    }

  //}
  @include mobile() {
    h1 {
      font-size:2rem;
    }
  }

</style>
